// @flow
import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import media from '../../styles/media'
import BenefitIcons from '../../components/BenefitIcons'
import Button from '../../components/Button'

const ImageSectionContainer = styled.section`
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;

  &::after {
    content: '';
    display: table;
    clear: both;
  }

  ${media.smUp} {
    width: 540px;
  }

  ${media.mdUp} {
    width: 720px;
  }

  ${media.lgUp} {
    width: 960px;
  }

  ${media.xlUp} {
    width: 1140px;
  }
`

const ImageSectionContent = styled.section`
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  padding: 4rem 2rem;

  ${media.smUp} {
    padding: 8rem 2rem;
  }
`

const Lead = styled.p`
  font-size: 1.25rem;
  font-weight: 300;
`

const BuyAnyHome = () => (
  <div>
    <Helmet title="Buy Homes Online" />
    <div
      style={{
        background: 'url("/static/images/buy-any-home.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'top'
      }}
    >
      <ImageSectionContainer>
        <div
          className="col-xl-5 col-lg-6 col-md-8 col-xs-12"
          style={{ padding: 0 }}
        >
          <ImageSectionContent>
            <h2>Buy a home listed on any website.</h2>
            <Lead>We can still be your personal advisors and consultants.</Lead>
            <Lead>
              No matter where you find the home you want, save when you buy with
              Kief Realty.
            </Lead>
          </ImageSectionContent>
        </div>
      </ImageSectionContainer>
    </div>
    <div style={{ padding: '3rem 0' }}>
      <div className="container">
        <div style={{ marginBottom: '6rem' }}>
          <h1>Can&apos;t I just do this myself?</h1>
          <p>
            We know you could. All we&apos;re saying is that you don&apos;t need
            to. With a buyer&apos;s agent representing you, you&apos;re tapping
            into an established source of knowledge and experience to work on
            your behalf. Not to mention someone to handle all the leg work and
            formalities for you, so you can spend your time on more important
            priorities such as family, friends and leisure. And keep in mind our
            service is FREE.
          </p>
          <h1>Shouldn&apos;t I just get in touch with the listing agent?</h1>
          <p>
            If you feel most comfortable going that route, then you certainly
            can do so. However, times have changed when it comes to representing
            sellers and buyers in real estate these days. Each side, both
            sellers and buyers, can have dedicated representation from their own
            Realtor who is fully committed to working on their behalf and their
            behalf only. If you work with the listing agent directly, how can
            they truly be looking out for your best interests? Oh and did we
            mention our service is FREE.
          </p>
        </div>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h2>
            Always remember &ldquo;The 3 EFFs&rdquo; when hiring our
            buyer&apos;s agents.
          </h2>
          <p>It&apos;s efficient. It&apos;s effective. It&apos;s FREE.</p>
        </div>
        <BenefitIcons />
        <div style={{ margin: '4rem 0', textAlign: 'center' }}>
          <Button color="primary" to="/rebate">
            Learn more about our rebate
          </Button>
        </div>
      </div>
    </div>
  </div>
)

export default BuyAnyHome



// WEBPACK FOOTER //
// ./src/views/BuyAnyHome/index.js